import { render } from "./CustomerReviews.vue?vue&type=template&id=ac1b5e20&ts=true"
import script from "./CustomerReviews.vue?vue&type=script&lang=ts"
export * from "./CustomerReviews.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__